// extracted by mini-css-extract-plugin
export var buttonContent = "NavigationButton-module--buttonContent--bd45f";
export var buttonText = "NavigationButton-module--buttonText--8ebc5";
export var navButton = "NavigationButton-module--navButton--02ceb";